import React from 'react'
import moment from 'moment'

// AC-8 — Order Detail: Veto Review Progress & Result. Read-only view of the
// per-veto-person review sections (order.veto_review), shown below the Audit
// Reports section for every role with access to Order Detail — both while the
// review is in progress and after it completes. No edit/upload from here.
export default class VetoReviewProgress extends React.Component {
  render () {
    const { order, accessToken } = this.props
    const sections = order.veto_review || []
    if (sections.length === 0) return null

    const total = sections.length
    const published = sections.filter(s => s.status === 'Published').length
    const inProgress = published < total

    return (
      <div className='widget'>
        <div className='widget-header'>
          <h3><i className='fa fa-gavel' /> Veto Review</h3>
        </div>
        <div className='widget-content'>
          {inProgress && (
            <div style={{ marginBottom: 15 }}>
              <b>{published} of {total} sections published</b>
              <div className='progress' style={{ height: 8, marginBottom: 0, marginTop: 6 }}>
                <div
                  className='progress-bar'
                  style={{ width: `${(published / total) * 100}%` }}
                />
              </div>
            </div>
          )}

          {sections.map(section => this.renderSection(section, accessToken))}
        </div>
      </div>
    )
  }

  renderSection (section, accessToken) {
    const isPublished = section.status === 'Published'
    return (
      <div key={section.user_id} className='panel panel-default' style={{ marginBottom: 12 }}>
        <div
          className='panel-heading'
          style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}
        >
          <b>{section.name}</b>
          <span>
            {(section.standards || []).map(s => (
              <span key={s.id} className='label label-success' style={{ marginLeft: 4 }}>{s.name}</span>
            ))}
          </span>
          {isPublished && (
            <span
              className={`label ${section.verdict === 'Approve' ? 'label-success' : 'label-danger'}`}
              style={{ marginLeft: 'auto' }}
            >
              {section.verdict === 'Approve' ? 'APPROVED' : 'NEED REVISE'}
            </span>
          )}
        </div>
        <div className='panel-body'>
          {isPublished ? (
            <div>
              <div style={{ marginBottom: 8 }}>
                <small className='text-muted' style={{ display: 'block', fontWeight: 700 }}>
                  VETO &amp; REVIEWER FEEDBACK
                </small>
                {(section.documents || []).length > 0 ? (
                  section.documents.map(d => (
                    <div key={d.id}>
                      <a href={`${process.env.REACT_APP_BASE_API}/download/${d.id}?token=${accessToken}`}>
                        <i className='fa fa-download' /> {d.detail && d.detail.name ? d.detail.name : 'Document'}
                      </a>
                    </div>
                  ))
                ) : (
                  <span className='text-muted'><em>No file uploaded</em></span>
                )}
              </div>
              <div style={{ marginBottom: 8 }}>
                <small className='text-muted' style={{ display: 'block', fontWeight: 700 }}>
                  REMARKS
                </small>
                {section.remarks || <span className='text-muted'>—</span>}
              </div>
              <div>
                <small className='text-muted' style={{ display: 'block', fontWeight: 700 }}>
                  PUBLISHED BY
                </small>
                <b>{section.published_by_name || '—'}</b>
                {section.published_at
                  ? ' · ' + moment.unix(section.published_at).format('DD MMM YYYY, HH:mm')
                  : ''}
              </div>
            </div>
          ) : (
            <span className='text-muted'>
              <em>
                Not published yet — no content to show until {section.name} clicks
                Approve or Need Revise.
              </em>
            </span>
          )}
        </div>
      </div>
    )
  }
}